import { cmsSimplePageRoutePath } from '@bcf-v2/routes-statics/common/app/paths/cms-simple-page-route-path';
import { SpSidebarLink } from '../types';

export const spSidebarLinksFn = (): SpSidebarLink[] => [
  {
    url: cmsSimplePageRoutePath('terms-and-conditions'),
    title: $localize`Terms and conditions`
  },
  {
    url: cmsSimplePageRoutePath('responsible-gaming'),
    title: $localize`Responsible gaming`
  },
  {
    url: cmsSimplePageRoutePath('standard-promotion-and-bonus-terms'),
    title: $localize`Bonus terms`
  },
  {
    url: cmsSimplePageRoutePath('privacy-policy'),
    title: $localize`Privacy Policy`
  },
  {
    url: cmsSimplePageRoutePath('refund-policy'),
    title: $localize`Refund policy`
  },
  {
    url: cmsSimplePageRoutePath('about-us'),
    title: $localize`About us`
  }
];
